import { render, staticRenderFns } from "./MonetaryDebtForm.vue?vue&type=template&id=3a4aeb1c&scoped=true&"
import script from "./MonetaryDebtForm.vue?vue&type=script&lang=js&"
export * from "./MonetaryDebtForm.vue?vue&type=script&lang=js&"
import style0 from "./MonetaryDebtForm.vue?vue&type=style&index=0&id=3a4aeb1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4aeb1c",
  null
  
)

export default component.exports